<template name="launchPageList">
  <!-- 已发布的页面 从二级项目管理的发布页面迁移 -->
  <div>
    <div v-if="showPage==1">
      <div class="info-card">
        <span class="title-style">已发布脚本管理</span>
      </div>

      <!-- 搜索部分 -->
      <div style="display: flex;justify-content: center;">
        <el-input style="width: 60%;margin-right: 10px"
                  placeholder="输入发布脚本名称"
                  v-model="searchTitle" @clear="clear"
                  clearable>
        </el-input>
        <el-button icon="el-icon-search" circle @click="getScriptPublishedList"></el-button>
      </div>


      <div style="margin-top: 10px;">
        <el-table :data="scriptList" style="width: 100%;text-align: center; height: 100%; " border ref="refTable"
                  :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
          <el-table-column prop="id" label="id" width="83" show-overflow-tooltip align="center"/>
          <el-table-column prop="scriptName" label="脚本名称" width="250" show-overflow-tooltip align="center"/>
          <el-table-column prop="description" label="脚本描述" width="250" show-overflow-tooltip align="center"/>
          <el-table-column prop="createTime" label="脚本创建时间" width="250" show-overflow-tooltip align="center"/>
          <el-table-column  label="设计" min-width="110" show-overflow-tooltip align="center">
            <template v-slot="scope">
              <el-button icon="el-icon-s-promotion" type="primary" circle @click="design(scope.row)"></el-button>
            </template>
          </el-table-column>
          <el-table-column  label="修改" min-width="110" show-overflow-tooltip align="center">
            <template v-slot="scope">
              <el-button icon="el-icon-edit" type="primary" circle @click="handleEditIdBtnClick(scope.row)"></el-button>
            </template>
          </el-table-column>
          <el-table-column  label="重新发布" min-width="110" show-overflow-tooltip align="center">
            <template v-slot="scope">
              <el-button icon="el-icon-upload" type="success" circle @click="republishScript(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog title="修改脚本名称" :visible.sync="show">
        <el-form>
          <el-form-item label="脚本名称" label-width="120px">
            <el-input v-model="tempTitle" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="脚本描述" label-width="120px">
            <el-input v-model="tempDescription" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="show=false">取 消</el-button>
          <el-button type="primary" @click="show=false;handleConfirmBtnClick();">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="确认重新发布脚本？" :visible.sync="republishScriptDialogVisible">
        <div slot="footer" class="dialog-footer">
          <el-button @click="republishScriptDialogVisible=false">取 消</el-button>
          <el-button type="primary" @click="handleRepublishScript">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import API from "@/../config/api.js";
import IMGURL from "@/../config/imgUrl.js";
import CheckMixin from "@/components/ScriptComponents/Mixins/CheckMixin";

export default {
  name: "launchScriptList",
  mixins: [CheckMixin],
  data() {
    return {
      scriptList: [],
      userId: '',
      logoProduct: IMGURL.logoProduct, //logo图片
      logoDelLaunch: IMGURL.logoDelLaunch, //logo图片
      productId: 0,  //记录权限是哪个页面的
      showPage: 1, //控制页面展示和权限页面展示

      show: false, //修改页面名字
      tempTitle: '', //记录修改框里出现的名称，传入后端
      tempScriptId: 0,
      tempDescription: '', //记录修改框里出现的描述，传入后端

      searchTitle: '', //搜索页面名字

      republishScriptDialogVisible: false,//重新发布页面对话框
      republishScriptItem: {},

      //发布脚本的参数
      script:'',
      content:'',
      updateVariableId:0,
      variableList: [],
      variableIdList: [],
      updateVariable:'',
      TriggerVariableIds: '',

    }
  },
  //此处定义传入的数据
  props: {
    companyId: Number,
  },
  mounted() {
    this.userId = window.localStorage.getItem('userid');
    this.getScriptPublishedList()
    this.getVariableList();
  },

  methods: {
    //修改脚本和描述名字
    handleEditIdBtnClick(item) {
      console.log(item)
      this.show = true
      this.tempTitle = item.scriptName
      this.tempDescription = item.description
      this.tempScriptId = item.id
      console.log('this.tempScriptId', this.tempScriptId)
    },

    //修改脚本名字和描述与后端
    handleConfirmBtnClick() {
      console.log('this.tempScriptId', this.tempScriptId)
      if (!this.tempTitle) {
        this.$message({
          message: '脚本名不能为空',
          type: 'warning'
        })
        this.show = false
        return
      }
      if (!this.tempDescription) {
        this.$message({
          message: '脚本描述不能为空',
          type: 'warning'
        })
        this.show = false
        return
      }
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,
        id: this.tempScriptId,
        scriptName: this.tempTitle,
        description: this.tempDescription
      }
      this.$axiosRequest({
        url: API.updateScript,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          if (res.data > 0) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.show = false
            for (let i = 0; i < this.scriptList.length; i++) {
              if (this.scriptList[i].id == this.tempScriptId) {
                this.scriptList[i].scriptName = this.tempTitle
                this.scriptList[i].description = this.tempDescription
                break;
              }
            }
            this.$emit('changeName', this.tempTitle, this.tempScriptId) //向外抛出修改名字的事件
          } else if (res.data == 0) {
            this.$message({
              message: '标题已经存在',
              type: 'warning'
            });
            this.show = false
            return
          } else if (res.data == -2) {
            this.$message({
              message: '参数错误',
              type: 'warning'
            });
            this.show = false
            return
          } else if (res.data == -1) {
            this.$message({
              message: '保存出错',
              type: 'warning'
            });
            this.show = false
            return
          }

        }
      });
    },
    //直接跳转设计脚本的页面
    design(item){
      this.$emit('design',item)
      console.log('eeeeee',item);
    },
    //清空发布脚本搜索框
    clear() {
      this.scriptList.length = 0;   //重新刷新一下    //先把列表清空
      this.getScriptPublishedList();
    },

    getScriptPublishedList() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded",
      }

      let data = {
        companyId: this.companyId,
        scriptName: this.searchTitle,
        publishStatus: 1
      }

      this.$axiosRequest({
        url: API.getScriptList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          this.scriptList = res.data["scriptList"];
        }
      });

    },
    //重新发布
    handleRepublishScript() {
      console.log(this.content)
      this.saveSript(1);
      let res = this.check(this.content, this.variableList)
      if (res !== "未发现问题") {
        this.$message({
          message: res,
          type: 'warning',
        })
        return
      }
      let item = this.republishScriptItem;
      let header = {
        "Content-Type": "application/x-www-form-urlencoded",
      }
      let data = {
        id: item.id,
        companyId: this.companyId
      }
      // 获取非当前用户的其他所有用户
      this.$axiosRequest({
        url: API.publishScript,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          console.log(res.data);
          if (res.data > 0) {
            this.$message({
              message: '发布成功',
              type: 'success',
            })
            this.republishScriptDialogVisible = false;
          } else if (res.data == -2) {
            this.$message({
              message: '参数出错',
              type: 'warning'
            })
          } else if (res.data == -1) {
            this.$message({
              message: '系统错误，发布失败',
              type: 'warning'
            })
          } else if (res.data == -3) {
            this.$message({
              message: '脚本语法错误',
              type: 'warning'
            })
          }
        }
      });
    },
    //重新发布脚本
    republishScript(item) {
      this.script=[];
      this.republishScriptItem = item;
      this.republishScriptDialogVisible = true;
      this.getScript();//先获取脚本现在的内容
    },
    // 获得要发布的当前脚本内容
    getScript() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,
        id: this.republishScriptItem.id
      }
      this.$axiosRequest({
        url: API.getScriptById,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          this.script = res.data['script']
          this.content = this.script["scriptSource"]
          this.updateVariableId = this.script["updateVariableId"]
        }
      });
    },
  }

}
</script>

<style lang="less">

.info-title {
  font-size: 18px;
  font-weight: bold;
  color: #004768;
  font-family: '仿宋';
}

.info-content {
  font-size: 18px;
  font-family: '仿宋';
}

.info-card {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  padding: 12px;
}

.info-content {
  margin: 10px 0px 10px 10px; // 上 右 下 左
  height: auto;
}

.title-style {
  font-size: 18px;
  font-weight: bold;
}

.title2-style {
  font-size: 15px;
  //font-weight: bold;
  line-height: 40px;
}

.title3-style {
  font-size: 12px;
  line-height: 40px;
  color: gray
}

.button-group-card {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  padding: 12px;
}

.button-group-title {
  font-size: 18px;
  font-weight: bold;
}

.button-group-card2 {
  // background-color: rgba(240, 240, 240, 0.5);
  padding: 12px;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed
}

.button-group-title2 {
  font-size: 18px;
  font-weight: bold;
  width: 450px;
  margin-left: 900px;
}

</style>

